import { useMemo } from 'react';
import ProductCard from '../product-card/product-card.component';

const CategoryWithTitles = ({ products }) => {
  // Regroupement dérivé des props : avec un state + useEffect, le premier rendu se
  // ferait sur un objet vide avant de se corriger au rendu suivant.
  const groups = useMemo(() => {
    const bySubTitle = {};

    products.forEach((product) => {
      const subTitle = product.categoryTitle;
      if (!bySubTitle[subTitle]) {
        bySubTitle[subTitle] = [];
      }
      bySubTitle[subTitle].push(product);
    });

    return bySubTitle;
  }, [products]);

  return (
    <div>
      {Object.entries(groups).map(([subTitle, items]) => (
        <div className="category-group" key={subTitle}>
          <h2 className="category-split-title">{subTitle}</h2>
          <div className="product-grid">
            {items.map((product) => (
              <ProductCard key={product?.id} product={product} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CategoryWithTitles;
